import { render, staticRenderFns } from "./ProtectedRouteLoader.ts.vue?vue&type=template&id=0d35f7bf&scoped=true&"
import script from "./ProtectedRouteLoader.ts.vue?vue&type=script&lang=ts&"
export * from "./ProtectedRouteLoader.ts.vue?vue&type=script&lang=ts&"
import style0 from "./ProtectedRouteLoader.ts.vue?vue&type=style&index=0&id=0d35f7bf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d35f7bf",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VOverlay,VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0d35f7bf')) {
      api.createRecord('0d35f7bf', component.options)
    } else {
      api.reload('0d35f7bf', component.options)
    }
    module.hot.accept("./ProtectedRouteLoader.ts.vue?vue&type=template&id=0d35f7bf&scoped=true&", function () {
      api.rerender('0d35f7bf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ProtectedRouteLoader.ts.vue"
export default component.exports